import { COLOR_SWATCH_MAP } from 'constants/colorSwatchMap';
import type { FacetComponentProps } from 'components/search/FacetAccordion/FacetAccordion.types';
import { cn } from 'helpers/classnames';
import { getTestId } from 'utils/testing';

export const SwatchFacet = ({ label, color, count, isSelected, imgUrl, testId, onClick }: Extract<FacetComponentProps, { type: 'swatch' }>) => {
  // Paint the circle from the known color name immediately (pure CSS, no network) so the
  // swatch shows its color on first render. The SVG in imgUrl layers on top and overtakes
  // this fill once it loads, resolving the exact shade. `background` (not background-color)
  // because some COLOR_SWATCH_MAP values are gradients (multi, metallic, animal print).
  const fallbackColor = color ? COLOR_SWATCH_MAP[color.toLowerCase()] : undefined;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={isSelected}
      data-test-id={getTestId(testId)}
      className={cn(
        'bg-white flex w-full items-center gap-2 rounded-sm border px-2 py-3 text-left hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-900 focus-visible:ring-offset-2 md:gap-1.5 md:px-1',
        isSelected ? 'border-gray-900 ring-1 ring-gray-900' : 'border-gray-300'
      )}
    >
      <span
        className={cn('size-4 shrink-0 rounded-full', !fallbackColor && 'bg-gray-200')}
        style={fallbackColor ? { background: fallbackColor } : undefined}
      >
        {imgUrl && <img src={imgUrl} alt="" className="box-border size-full rounded-full border border-gray-500 object-cover" />}
      </span>
      <span className="body-s truncate leading-none text-gray-900">{label}</span>
      <span className="body-xs ml-auto text-gray-500">{count}</span>
    </button>
  );
};
